


























import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class NewsCard extends Vue {
  @Prop({ default: null })
  date: Date | null

  @Prop({ default: () => [] })
  tags: string[]

  @Prop({ type: Boolean, default: false })
  ita: boolean

  @Prop({ type: Boolean, default: false })
  collapsable: boolean

  open = false

  get formattedDate (): string {
    if (!this.date) return ''
    const day = this.date.getDate() > 9 ? `${this.date.getDate()}` : `0${this.date.getDate()}`
    const monthN = this.date.getMonth() + 1
    const month = monthN > 9 ? `${monthN}` : `0${monthN}`
    return `${day}/${month}/${this.date.getFullYear()}`
  }

  created () {
    if (!this.collapsable) {
      this.open = true
    }
  }

  toggleCollapse () {
    if (this.collapsable) {
      this.open = !this.open
    }
  }
}
